import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { AuthLoginService } from '../auth/services/auth-login.service';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';
import { LoginToken } from '../auth/model/login-token.model';
import { HttpErrorResponse } from '@angular/common/http';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public companyParamsService: CompanyParamsService,
    public authLoginService: AuthLoginService,
    public http: HttpRequestService,
    public localStorageService: LocalStorageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  redirectURL = "";
  loginError: boolean = false;
  errorMessage: string = '';
  urlImage:string = "";

  ngOnInit(): void {
    let params = this.route.snapshot.queryParams;
    if (params['redirectURL']) {
      this.redirectURL = params['redirectURL'];
    }
    if (isPlatformBrowser(this.platformId)) {
      let url = window.location.pathname;
      let companyName = url.split('/')[1];
      this.urlImage = 'assets/images/backgrounds/login/'+companyName+'.jpg';
    }
  }

  backToPreviousPage(email: string, password: string) {
    this.loginError = false;
    this.errorMessage = '';
    this.authLoginService.fetchToken(email, password).subscribe(
      (response: LoginToken) => {
        this.localStorageService.saveData(this.companyParamsService.getCode() + '-loginToken', response.idToken);
        if (this.redirectURL) {
          //add data to localstorage
          this.router.navigateByUrl(this.redirectURL)
            .catch(() => this.router.navigate(['search']));
        } else {
          this.router.navigate(['search'])
        }
      },
      (error: HttpErrorResponse) => {
        this.loginError = true;
        this.errorMessage = 'Wrong user or password.'
      }
    );
  }
}
